import React from 'react';
import styled from 'styled-components';
import { Label } from 'reactstrap';

import PadlockIcon from 'js/components/core/Icons/PadlockIcon';

const Icon = styled(PadlockIcon)`
  width: 0.75rem;
`;

export default styled(({ className, forId, spinner, hasAddress }) => (
  <Label for={forId} className={className}>
    <Icon title="Type your address and select it from the drop down" />
  </Label>
))`
  display: block;
  position: absolute;
  top: 0;
  right: 0;
  width: 40px;
  line-height: 3rem;
  text-align: center;
  cursor: pointer;
`;
